import { api } from "@/utils/axios";

export const baseService = {
  placeList() {
    return api.post("?c=Port&m=Web_Port&module=Set_base&opt=place_list&need=1");
  },
  departmentList() {
    return api.post("?c=Port&m=Web_Port&module=Set_base&opt=department_list");
  },
  faultTypeList() {
    return api.post("?c=Port&m=Web_Port&module=Set_base&opt=faulttype_list");
  },
  upload(file) {
    const formData = new FormData();
    formData.append("file_imgs", file);
    return api.post("?c=Port&m=Web_Port&module=Files&opt=save_files", formData);
  },
  collectionList() {
    return api.post("?c=Port&m=Web_Port&module=Set_base&opt=collection_list");
  },
  dispatchUserList(body) {
    return api.post(
      "?c=Port&m=Web_Port&module=Set_user&opt=dispatch_user_list",
      body
    );
  },
  storageList(body) {
    return api.post(
      "?c=Port&m=Web_Port&module=Set_base&opt=storage_list",
      body
    );
  },
};
